'use client'

import { AutoPlayConfig, HomeAwardsList } from 'modules/constant'
import Image from 'next/image'
import 'swiper/css/effect-fade'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/autoplay'
import { Autoplay, EffectFade, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { TrackExposure, TrackHomeSection, TrackSwiperNavigation } from 'modules/analysis'

export function Awards() {
  return (
    <TrackExposure config={{ sectionName: TrackHomeSection.Awards }}>
      <div className="relative w-full">
        <div className="pure-blur-40 absolute inset-0 z-[1] m-auto h-[412px] w-[500px] rounded-[491.5px] bg-[rgba(208,0,255,0.80)] bg-blend-soft-light"></div>
        <Swiper
          effect="fade"
          centeredSlides
          fadeEffect={{ crossFade: true }}
          modules={[EffectFade, Autoplay, Navigation]}
          className="w-full"
          navigation
          speed={1500}
          autoplay={AutoPlayConfig}
          loop
        >
          <TrackSwiperNavigation config={{ sectionName: TrackHomeSection.AwardsSlide }} />
          {HomeAwardsList.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <div className="flex-y-center section-content h-full w-full">
                  <Image src={item.title} alt="award_title" className="mb-10 h-auto max-h-[150px] w-auto" />
                  <Image src={item.content} alt="award" className="h-full max-h-[440px] w-auto" />
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </TrackExposure>
  )
}
